import React from 'react';
import Container from 'react-bootstrap/Container';

const ThankYou = () => {
    return (
        <div>

            {/* Breadcrumb Navigation */}
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <h1>Thank You</h1>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li>Thank You</li>
                    </ul>
                </div>
            </section>

            {/* Thank You Message Section */}
            <section className="entry py-5">
                <Container>
                    <h2 className="text-center mb-3">Thank You For Your Message!</h2>
                    <p className="text-center">Message sent successfully. We have received your inquiry and will contact you shortly.</p>
                    <p className="text-center">Click to return to the <a href="/">Homepage</a>.</p>
                </Container>
            </section>
            
        </div>
    );
};

export default ThankYou;
